"use client";
import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Stack,
  styled,
  Container,
} from "@mui/material";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import ShareIcon from "@mui/icons-material/Share";
import Image from "next/image";
import { Plus_Jakarta_Sans } from "next/font/google";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { IMAGES } from "../constants/images";
import { useTranslation } from "react-i18next"; // ← ADD

const PlusJakartaSans = Plus_Jakarta_Sans({
  subsets: ["latin"],
  weight: ["300", "400", "500", "600", "700"],
});

const SocialStack = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(2),
  "& .MuiIconButton-root": {
    padding: 0,
    color: theme.palette.text.secondary,
  },
}));

const ArticleFiveMainSection = () => {
  const { t, i18n } = useTranslation(); // ← ADD
  const isArabic = i18n.language === "ar"; // ← ADD

  return (
    <Container
      maxWidth="xl"
      sx={{
        my: 4,
        mt: { xs: "22%", lg: "7%" },
        direction: isArabic ? "rtl" : "ltr", // ← ADD
      }}
    >
      <Box sx={{ borderRadius: "24px", p: "2px", background: "#fff" }}>
        <Box
          sx={{
            borderRadius: "22px",
            border: "1px solid #E2E8F0",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", lg: "row" },
              alignItems: "stretch",
            }}
          >
            {/* Image Section */}
            <Box
              sx={{
                position: "relative",
                width: { xs: "100%", lg: "53%" },
                height: { xs: "300px", sm: "400px", md: "450px", lg: "493px" },
                borderBottom: { xs: "3px solid #E2E8F0", lg: "none" },
                borderRight: isArabic // ← REPLACE
                  ? "none"
                  : { xs: "none", lg: "3px solid #E2E8F0" },
                borderLeft: isArabic // ← ADD
                  ? { xs: "none", lg: "3px solid #E2E8F0" }
                  : "none",
              }}
            >
              <Image
                src={IMAGES.ARTICLE_5_IMG}
                alt="Dice illustration"
                fill
                style={{ width: "100%", height: "100%" }}
                priority
              />
            </Box>

            {/* Content Section */}
            <Box
              sx={{
                width: { xs: "100%", lg: "47%" },
                p: { xs: 2, sm: 3, md: 4, lg: 5 },
                textAlign: isArabic ? "right" : "left", // ← ADD
              }}
            >
              {/* Tags and Read Time */}
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}
              >
                <Box
                  sx={{
                    backgroundColor: "#9048FB",
                    borderRadius: "20px",
                    px: 2,
                    py: 0.8,
                  }}
                >
                  <Typography
                    sx={{
                      color: "white",
                      fontSize: "15.15px",
                      fontWeight: 500,
                      fontFamily: PlusJakartaSans.style.fontFamily,
                    }}
                  >
                    {t("articleFive.category")} {/* ← REPLACE */}
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    color: "#111111",
                    fontSize: "15.15px",
                    fontFamily: PlusJakartaSans.style.fontFamily,
                  }}
                >
                  {t("articleFive.readTime")} {/* ← REPLACE */}
                </Typography>
              </Box>

              {/* Title */}
              <Typography
                sx={{
                  fontSize: {
                    xs: "24px",
                    sm: "32px",
                    md: "38px",
                    lg: "43.29px",
                  },
                  fontWeight: 700,
                  mb: isArabic ? 5 : 2, // ← MATCH ArticleOneMain pattern
                  lineHeight: 1.2,
                  fontFamily: PlusJakartaSans.style.fontFamily,
                  color: "#111111",
                }}
              >
                {t("articleFive.title")} {/* ← REPLACE */}
              </Typography>

              {/* Description */}
              <Typography
                sx={{
                  mb: 4,
                  fontSize: { xs: "14px", sm: "16px" },
                  lineHeight: 1.6,
                  fontFamily: PlusJakartaSans.style.fontFamily,
                  color: "#111111",
                  fontWeight: 400,
                }}
              >
                {t("articleFive.description")} {/* ← REPLACE */}
              </Typography>

              {/* Author Section */}
              <Stack
                direction="row"
                spacing={1.5}
                alignItems="center"
                sx={{ mb: 2 }}
              >
                <AccountCircleOutlinedIcon
                  sx={{ height: "42px", width: "42px", color: "#4B5963" }}
                />
                <Box>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: { xs: "13px", sm: "14px" },
                    }}
                  >
                    Mahtab Fatima
                  </Typography>
                  <Typography
                    sx={{
                      color: "text.secondary",
                      fontSize: { xs: "12px", sm: "14px" },
                    }}
                  >
                    Senior Marketing Manager • March 31, 2024
                  </Typography>
                </Box>
              </Stack>

              {/* Social Icons */}
              <SocialStack
                sx={{
                  ml: isArabic ? 0 : "2%", // ← REPLACE
                  mr: isArabic ? "2%" : 0, // ← ADD
                  mt: "1%",
                }}
              >
                <IconButton size="small">
                  <TwitterIcon fontSize="medium" />
                </IconButton>
                <IconButton size="small">
                  <LinkedInIcon fontSize="medium" />
                </IconButton>
                <IconButton size="small">
                  <FacebookIcon fontSize="medium" />
                </IconButton>
                <IconButton size="small">
                  <ShareIcon fontSize="medium" />
                </IconButton>
              </SocialStack>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default ArticleFiveMainSection;
